<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        Modifica Admin
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field label="Nome" v-model="nome" outlined></v-text-field>
          </v-col>
          <v-col cols="12"> </v-col>
          <v-col cols="12">
            <v-text-field label="Email" v-model="email" outlined></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="Telefono"
              v-model="telefono"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12"> </v-col>
        </v-row>
        <v-divider />
        <v-row no-gutters>
          <v-col cols="12">
            <v-switch
              v-model="pushEnabled"
              inset
              label="Notifiche Push"
            ></v-switch>
          </v-col>
          <v-switch
            v-model="phoneEnabled"
            inset
            label="Allarme Telefonico"
          ></v-switch>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="dialog = false">Annulla </v-btn>
        <v-btn color="green" outlined @click="salva()">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModificaAdmin",
  props: {
    admin: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      nome: "",
      email: "",
      telefono: "",
      phoneEnabled: false,
      pushEnabled: false,
    };
  },
  methods: {
    open() {
      this.nome = this.admin.nome;
      this.email = this.admin.email;
      this.telefono = this.admin.telefono;
      this.phoneEnabled = this.admin.phoneEnabled || false;
      this.pushEnabled = this.admin.pushEnabled || false;
      this.dialog = true;
    },
    salva() {
      this.$store.dispatch("updateAdmin", {
        id: this.admin.iva,
        nome: this.nome,
        email: this.email,
        telefono: this.telefono,
        phoneEnabled: this.phoneEnabled,
        pushEnabled: this.pushEnabled,
      });
      this.dialog = false;
    },
  },
};
</script>
